import { h } from 'preact';
export const Share2 = (props) => {
    const color = props.color || 'currentColor';
    const size = props.size || 24;
    delete props.color;
    delete props.size;
    return (h("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: size, height: size, viewBox: "0 0 24 24", fill: "none", stroke: color, "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }, props),
        h("circle", { cx: "18", cy: "5", r: "3" }),
        h("circle", { cx: "6", cy: "12", r: "3" }),
        h("circle", { cx: "18", cy: "19", r: "3" }),
        h("line", { x1: "8.59", y1: "13.51", x2: "15.42", y2: "17.49" }),
        h("line", { x1: "15.41", y1: "6.51", x2: "8.59", y2: "10.49" })));
};
//# sourceMappingURL=share-2.js.map